<template>
  <el-select
    v-model="fbacode"
    @change="getCty"
    filterable
    clearable
    placeholder="请选择code"
    size="small"
  >
    <el-option
      v-for="(item,index) in options"
      :key="index"
      :label="item.code+'/'+item.zip"
      :value="item.code"
    ></el-option>
  </el-select>
</template>

<script>
import httpApi from "@/http/api";
export default {
  name: "fbacode",
  props: {
    fbacodes: { String }
  },
  data() {
    return {
      options: [], //国家列表
      fbacode: this.fbacodes
    };
  },
  methods: {
    getCty(e) {
      this.$emit("getCty", e);
    },
    init() {
      let that = this;
      httpApi
        .listUserParams({
          params: {
            type: "sys_fbacode",
            enable: "1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.options = res.data.data;
          }
        })
        .catch(() => {
          httpApi.listParams({
            params: { type: "sys_fbacode", enable: "1" }
          }).then(res => {
            if (res.data.code == "ok") that.options = res.data.data;
          });
        });
    }
  },
  created() {
    this.init();
  },
  watch: {
    fbacodes: function(newVal) {
      this.fbacode = newVal;
    }
  }
};
</script>

<style>
</style>